import styled from 'styled-components';

export const ContainerForm = styled.div`
    margin: 0px 30px;
`

export const TextDivider = styled.span`
    font-size: 16px;
    font-weight: 500;
`